/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
/**
 * 
 * @export
 * @interface CreateContactEventRequest
 */
export interface CreateContactEventRequest {
    /**
     * 
     * @type {number}
     * @memberof CreateContactEventRequest
     */
    eventId?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateContactEventRequest
     */
    contactId?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateContactEventRequest
     */
    utteranceId?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateContactEventRequest
     */
    extractionId?: number;
}

/**
 * Check if a given object implements the CreateContactEventRequest interface.
 */
export function instanceOfCreateContactEventRequest(value: object): boolean {
    return true;
}

export function CreateContactEventRequestFromJSON(json: any): CreateContactEventRequest {
    return CreateContactEventRequestFromJSONTyped(json, false);
}

export function CreateContactEventRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateContactEventRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'eventId': json['eventId'] == null ? undefined : json['eventId'],
        'contactId': json['contactId'] == null ? undefined : json['contactId'],
        'utteranceId': json['utteranceId'] == null ? undefined : json['utteranceId'],
        'extractionId': json['extractionId'] == null ? undefined : json['extractionId'],
    };
}

export function CreateContactEventRequestToJSON(value?: CreateContactEventRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'eventId': value['eventId'],
        'contactId': value['contactId'],
        'utteranceId': value['utteranceId'],
        'extractionId': value['extractionId'],
    };
}

